import { v4 as uuidv4 } from "uuid";

export const summaryOfRatings = {
    "blockId": uuidv4(),
    "goalId": "feedback360_summaryRating",
    "isHiddenFromEditSurvey": true,
    "questions": [],
    "type": "summaryRating",
    "dimension": "Summary of Ratings"
}